import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var IpRefreshService = /** @class */ (function () {
    function IpRefreshService() {
        this.headerMessage = "";
        this.popupContent = "";
        this.error = true;
        this.custIDs = '';
        this.subject = new Subject();
        this.ipRefreshSearch = new Subject();
    }
    IpRefreshService.prototype.setPopupDetails = function (headerMessage, popupContent, error) {
        this.headerMessage = headerMessage;
        this.popupContent = popupContent;
        this.error = error;
    };
    IpRefreshService.prototype.getPopupDetails = function () {
        return { "headerMessage": this.headerMessage, "popupContent": this.popupContent, "error": this.error };
    };
    IpRefreshService.prototype.setCustomerDetails = function (custIDs) {
        this.custIDs = custIDs;
    };
    IpRefreshService.prototype.getCustomerDetails = function () {
        return this.custIDs;
    };
    IpRefreshService.prototype.queueCustomerPopup = function () {
        this.subject.next();
    };
    IpRefreshService.prototype.getCustomerPopup = function () {
        return this.subject.asObservable();
    };
    IpRefreshService.prototype.queueFilesRefresh = function () {
        this.ipRefreshSearch.next();
    };
    IpRefreshService.prototype.getFilesRefresh = function () {
        return this.ipRefreshSearch.asObservable();
    };
    IpRefreshService.ngInjectableDef = i0.defineInjectable({ factory: function IpRefreshService_Factory() { return new IpRefreshService(); }, token: IpRefreshService, providedIn: "root" });
    return IpRefreshService;
}());
export { IpRefreshService };
